<div class="download-section-wrapper">
  <div class="download-flex-1">
    <div class="description">
      <sh-text size='super-header' scale='m' class="text-heading"> Download ExpertGuidance </sh-text>
      <sh-text size="body-1" >
        The ExpertGuidance App provides a quick and intuitive introduction to
        your Siemens Healthineers equipment, helping you get acquainted with its
        look, feel, and functionalities in real-time, on the go. It's a valuable
        addition to your facility's onboarding training.
      </sh-text>
    </div>

    <div class="download-flex">
    <sh-card class="card card-margin-right">
      <sh-text size="title-1" class="card-title"> Windows (Desktop) </sh-text>
      <sh-text size="body-1" [innerHTML]="latestBuildText" class="card-text"></sh-text>
      <div class="button-wrapper">
        <sh-button
          label="Download"
          size="auto"
          (click)="downloadLatestBuild()"
        ></sh-button>
      </div>
    </sh-card>

    <sh-card class="card">
      <sh-text size="title-1" class="card-title"> iOS (iPad/iPhone) </sh-text>
      <div class="qr-row">
        <sh-text size="body-1" style="padding-top: 2px;" [innerHTML]="latestIosBuildText" class="card-text">
        </sh-text>
        <img
          src="assets/images/QR-Code.png"
          alt="ExpertGuidance"
          class="qr-style"
        />
      </div>
    </sh-card>
</div>
  </div>
</div>
